import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        let clickCounter = 0;

        this.element.addEventListener('click', (event) => {
            clickCounter++;

            const emoji = document.createElement('span');

            if (clickCounter > 50) {
                emoji.textContent = "Du hast genug geklickt...";
            } else {
                emoji.textContent = this.getRandomEmoji();
            }
            emoji.classList.add('animation-emoji');
            document.body.appendChild(emoji);

            const x = event.clientX - (emoji.getBoundingClientRect().width / 2);
            const y = event.clientY - 40;

            emoji.style.position = 'fixed';
            emoji.style.left = `${x}px`;
            emoji.style.top = `${y}px`;

            emoji.addEventListener('animationend', () => {
                emoji.remove();
            });
        });
    }

    getRandomEmoji() {
        const emojiArray = ['✨', '🚀', '🔥', '❤️', '🦆', '🦖', '💥', '🦈', '🦄', '👻', '👽'];
        return emojiArray[Math.floor(Math.random() * emojiArray.length)];
    }
}
